<template>
    <div class="about">
        <div class="pg-header">
            <div>
                <label class="title">年度报告查询</label>
            </div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>统计管理</span>| <span>年度报告查询</span>
                </div>
            </div>
        </div>
        <div class="collapse-wrap">
            <div class="search-bar">
                <el-form ref="form" label-width="120px">
                    <div class="def-key">
                        <label>报告生成时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
                                type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions"
                                @change="handleFilter(0, $event)"></el-date-picker>
                        </label>

                        <div style="display: inline-block; margin-left: 6px">机构名称
                            <el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
                                @change="handleFilter(1, $event)">
                                <el-option v-for="item in orgList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div style="display: inline-block;margin-left: 6px">报告状态
                            <el-select size="small" filterable clearable v-model="filter.reportState" placeholder="请选择"
                                @change="handleFilter(1, $event)">
                                <el-option label="已生成" value="0"></el-option>
                                <el-option label="生成失败" value="1"></el-option>
                                <el-option label="生成中" value="2"></el-option>
                            </el-select>
                        </div>
                        <el-button class="btn-export flr" size="mini" round @click="resetForm">重置</el-button>
                        <el-button size="mini" round @click="handleFilter">搜索</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="collapse-wrap">
            <div class="table-wrap">
                <el-button size="mini" type="primary" round @click="openDlg" style="margin-bottom: 20px">新增报告</el-button>

                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                    :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
                    <el-table-column prop="orgName" label="机构名称" width="280"></el-table-column>
                    <el-table-column prop="param" label="报告时间"></el-table-column>
                    <el-table-column prop="createTime" label="生成时间"></el-table-column>
                    <el-table-column prop="reportState" label="报告状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.reportState == 0" class="r0">已生成</span>
                            <span v-if="scope.row.reportState == 1" class="r1">生成失败</span>
                            <span v-if="scope.row.reportState == 2" class="r2">生成中</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creatorName" label="操作人"></el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <div class="tab-action" v-if="scope.row.reportState != 2">
                                <template v-if="scope.row.reportState == 0">
                                    <el-tooltip content="查看" placement="top" target="_blank" :enterable="false">
                                        <i class="icon-research" style="color: #699CE4;"
                                            @click="viewpdf(scope.row.pdfUrl)"></i>
                                    </el-tooltip>
                                    <el-tooltip content="下载" placement="top" target="_blank" :enterable="false">
                                        <span @click="downpdf(scope.row.id)"><svg-icon iconName='icon-xiazai' /></span>
                                    </el-tooltip>
                                </template>
                                <el-popconfirm confirmButtonText='确定' title="确定删除吗？" @confirm="deleteReport(scope.row.id)">
                                        <el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
                                            <i class="el-icon-delete" style="color: #699CE4;"></i>
                                        </el-tooltip>
                                    </el-popconfirm>

                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-row>
                        <el-col :span="12">
                            <div class="record">
                                当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span v-text="(filter.pageNumber - 1) * filter.pageSize + filter.pageSize
                                    "></span>数据
                            </div>
                            <div class="record">
                                总计<span v-text="list.total"></span>条记录
                            </div>
                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                                :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <el-dialog title="新增报告" :width="stepAct == 1 ? '1208px' : '832px'" :visible.sync="dlg.active"
            :close-on-click-modal="false">
            <el-steps :active="stepAct">
                <el-step title="范围选择"></el-step>
                <el-step title="补充数据"></el-step>
                <el-step title="新增报告"></el-step>
            </el-steps>
            <el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form" v-if="stepAct == 0"
                style="margin-top: 70px;">
                <el-form-item label="报告时间" prop="date">

                    <el-date-picker size="small" style="width: 250px" v-model="form.date" type="monthrange" align="right"
                        unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="机构名称" prop="orgId">
                    <el-select size="small" filterable clearable v-model="form.orgId" placeholder="请选择"
                        style="width: 250px">
                        <el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form ref="form" label-width="120px" :model="form" v-if="stepAct == 1 && substep == 1">
                <p class="tit">主要慢病人群医疗费用<span>(选填)</span></p>

                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                    :data="HBPlist" style="width: 1121px;">
                    <el-table-column class-name="firstCell" prop="year" label="高血压"></el-table-column>
                    <el-table-column label="住院">
                        <el-table-column v-for="col in ['inPatientCount', 'inFeeCount', 'inFeeAvg']" :key="col" :prop="col"
                            :label="getLabel(col)">
                            <template #default="scope">
                                <el-input type="number" v-model="scope.row[col]" size="mini" style="width: 100%;"
                                    placeholder="请填写" />
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="门诊">
                        <el-table-column v-for="col in ['opPatientCount', 'opFeeCount', 'opFeeAvg']" :key="col" :prop="col"
                            :label="getLabel(col)">
                            <template #default="scope">
                                <el-input type="number" v-model="scope.row[col]" size="mini" style="width: 100%;"
                                    placeholder="请填写" />
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                    :data="DMlist" style="width: 1121px;margin-top: 30px;">
                    <el-table-column prop="year" class-name="firstCell" label="糖尿病"></el-table-column>
                    <el-table-column label="住院">
                        <el-table-column v-for="col in ['inPatientCount', 'inFeeCount', 'inFeeAvg']" :key="col" :prop="col"
                            :label="getLabel(col)">
                            <template #default="scope">
                                <el-input type="number" v-model="scope.row[col]" size="mini" style="width: 100%;"
                                    placeholder="请填写" />
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="门诊">
                        <el-table-column v-for="col in ['opPatientCount', 'opFeeCount', 'opFeeAvg']" :key="col" :prop="col"
                            :label="getLabel(col)">
                            <template #default="scope">
                                <el-input type="number" v-model="scope.row[col]" size="mini" style="width: 100%;"
                                    placeholder="请填写" />
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </el-form>
            <el-form ref="form" label-width="120px" :model="form" v-if="stepAct == 1 && substep == 2">
                <p class="tit">服务满意度<span>(选填)</span></p>
                <el-table ref="multipleTable" class="table2" header-cell-class-name="tab-cell" cell-class-name="tab-cell"
                    :data="tableData" style="width: 1121px;" border>
                    <el-table-column class-name="firstCell" prop="province" label="">
                    </el-table-column>
                    <el-table-column v-for="(year, index) in years" :key="index" :label="year + '年'">
                        <template #default="scope">
                            <el-input type="number" v-model="scope.row.rankings[index].sort" size="mini"
                                style="width: 100%;" placeholder="请填写" />
                        </template>
                    </el-table-column>
                </el-table>

            </el-form>
            <div v-if="stepAct == 2" class="endTips">
                <i class="el-icon-circle-check" style="color:#699CE4;"></i>
                <p>提交成功，请耐心等待</p>
                <p>
                    由于涉及的数据量较大，数据处理过程相对复杂，<br />疾病管理工作报告的生成可能需要一些时间
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <template v-if="stepAct == 2">
                    <el-button type="primary" @click="closeDlg">我知道了</el-button>
                </template>
                <template v-else>

                    <el-button :loading="isLoading" @click="closeDlg" v-if="stepAct != 1">取 消</el-button>
                    <el-button plain class="lastStep" :loading="isLoading" @click="toLastStep"
                        v-if="stepAct == 1">上一步</el-button>
                   
                    <el-button type="primary" :loading="isLoading" @click="saveForm1">
                        {{ substep==2?'生成报告':'保存，下一步' }}
                    </el-button>
                    <el-button type="info" plain class="passStep" :loading="isLoading" @click="passStepHandle"
                        v-if="stepAct == 1&&substep==1">跳过</el-button>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from "@/service/api.js";
import mixin from "@/views/mixin";
import dayjs from "dayjs";

export default {
    mixins: [mixin],
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '本月',
                    onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: '今年至今',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近六个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 6);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null,
            },
            filter: {
                endDate: "",
                startDate: "",
                orgId: '',
                pageNumber: 1,
                pageSize: 10,
                date: [],
                reportState: ''
            },
            deptList: [],
            permission: false,
            orgList: [],
            dlg: {
                active: false,
                rules: {
                    date: { required: true, message: '请选择报告时间' },
                    orgId: { required: true, message: '请选择机构' }
                }
            },
            form: {
                date: '',
                orgId: '',
                endDate: "",
                startDate: "",
            },
            stepAct: 0,
            substep: 1,
            DMlist: [],
            HBPlist: [],
            Servicelist: [],
            years: [],
            // 表格数据
            tableData: [],
        };
    },

    created() {
        let query = this.$route.query;
        const end = new Date();
        const start = new Date(new Date().getFullYear(), 0);
        this.form.date = [start, end];
        this.user = JSON.parse(localStorage.getItem('user')).data;

        // 获取机构下拉
        api.getListComboboxOrg().then((res) => {
            if (res.code == 1000) {
                this.orgList = res.data;
                this.orgList.map((item) => {
                    if (item.name == this.user.user.orgName.split(',')[0]) {
                        this.form.orgId = item.id;
                    }
                })
            } else {
                this.$message.error(res.message)
            }
        })
        // this.form.orgId = 1;
        this.loadList()

    },
    methods: {

        viewpdf(url) {
            window.open(url, '_blank')
        },
        getLabel(col) {
            const labels = {
                inPatientCount: '总人次',
                inFeeCount: '总费用',
                inFeeAvg: '次均费用',
                opPatientCount: '总人次',
                opFeeCount: '总费用',
                opFeeAvg: '次均费用',
            };
            return labels[col];
        },

        resetForm() {
            this.filter = {
                endDate: "",
                startDate: "",
                orgId: '',
                pageNumber: 1,
                pageSize: 10,
                date: [],
                reportState: ''
            }
            this.loadList()
        },
        async loadList() {
            this.isLoading = true;
            let res = await api.getAnnualReportList(this.filter);
            if (res.code == 500) {
                return this.$router.push({
                    name: "Login",
                    query: {
                        r: location.href
                    },
                });
            }
            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            if (res.code == 1000 && res.data) {

                this.list.data = res.data;
            }
            // 权限控制
            // this.user = JSON.parse(localStorage.getItem('user')).data;
            // this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
            this.isLoading = false;
        },
        openDlg() {
            this.dlg.active = true;
            this.stepAct = 0;
        },
        closeDlg() {
            this.dlg.active = false;
            this.stepAct = 0;
            this.substep = 1;
        },
        async toLastStep() {
            if (this.substep == 1) {
                this.stepAct = 0;
                let DMres = await api.checkAddOrModifyFee(this.DMlist)
                let HBPres = await api.checkAddOrModifyFee(this.HBPlist)
            } else if (this.substep == 2) {
                this.substep = 1;
                let res = await api.checkAddOrModify(this.Servicelist);
            }
        },
        passStepHandle(){
            this.saveForm1()
        },
        isEditing(row, col) {
            return this.editing[row.id] === col;
        },
        stopEditing(row, col) {
            this.$set(this.editing, row.id, col);
        },
        async saveForm1() {
            if (this.stepAct == 0) {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.stepAct++;
                        if (this.form.date) {
                            this.form.startDate = dayjs(
                                this.form.date[0]
                            ).format("YYYY-MM-DD 00:00:00");
                            this.form.endDate = dayjs(this.form.date[1]).format(
                                "YYYY-MM-DD 23:59:59"
                            );
                        } else {
                            this.form.startDate = "";
                            this.form.endDate = "";
                        }
                        this.loadNcdFee()
                    }
                })

            } else if (this.stepAct == 1 && this.substep == 1) {
                this.loadService()
                let DMres = await api.checkAddOrModifyFee(this.DMlist)
                let HBPres = await api.checkAddOrModifyFee(this.HBPlist)
                this.substep = 2;
            } else if (this.stepAct == 1 && this.substep == 2) {
                this.tableData[0].rankings.forEach(ranking => {
                    const bItem = this.Servicelist.find(item => item.year === ranking.year);
                    if (bItem) {
                        bItem.sort = parseInt(ranking.sort, 10);
                    }
                });

                let res = await api.checkAddOrModify(this.Servicelist);
                let endres = await api.getAnnualReport(this.form);

                this.stepAct = 2;
                this.substep = 1;
            }
            this.loadList()

        },
        async loadService() {
            let res = await api.getServiceSatisfaction(this.form)
            if (res.code == 1000) {
                this.Servicelist = res.data.map(item => {
                    return Object.fromEntries(
                        Object.entries(item).map(([key, value]) => [key, value === '-'||value === 0 ? '' : value])
                    );
                });
            }
            this.initializeTable()

        },
        initializeTable() {
            this.years = this.Servicelist.map(item => item.year);
            this.tableData = [
                {
                    province: "省排名", // 固定“省排名”
                    rankings: this.Servicelist.map(item => {
                        return {
                            year: item.year,
                            sort: item.sort,
                        }
                    }),
                },
            ];
        },
        async loadNcdFee() {
            let DMres = await api.getNcdDM(this.form)
            let HBPres = await api.getNcdHBP(this.form)
            if (DMres.code == 1000) {
                this.DMlist = DMres.data.map(item => {
                    return Object.fromEntries(
                        Object.entries(item).map(([key, value]) => [key, value === '-' ? '' : value])
                    );
                });
            }

            if (HBPres.code == 1000) {
                this.HBPlist = HBPres.data.map(item => {
                    return Object.fromEntries(
                        Object.entries(item).map(([key, value]) => [key, value === '-' ? '' : value])
                    );
                });
            }
        },
        // 过滤条件 更改
        handleFilter(key, val) {
            switch (key) {
                case 0:
                    if (this.filter.date) {
                        this.filter.startDate = dayjs(
                            this.filter.date[0]
                        ).format("YYYY-MM-DD 00:00:00");
                        this.filter.endDate = dayjs(this.filter.date[1]).format(
                            "YYYY-MM-DD 23:59:59"
                        );
                    } else {
                        this.filter.startDate = "";
                        this.filter.endDate = "";
                    }
                    break;

            }
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
        async downpdf(id) {
            let url = await api.downloadReport({ id: id });
            const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
        },
        async deleteReport(id) {
            let res = await api.deleteAnnualReport({ id: id })
            if (res.code == 1000) {
                this.$message.success('删除成功');
                this.loadList();
            }
        }
    },
};
</script>

<style lang="less" scoped>
@import "@/assets/style/var";
@import './components/sty.less';

.endTips {
    text-align: center;
    margin-top: 50px;

    i {
        font-size: 70px;
    }

    p {
        font-size: 18px;
        color: #616161;
        line-height: 32px;
    }
}

::v-deep .table2 {
    .el-table__header-wrapper {
        .el-table__cell {
            background-color: #F5F7FA;
        }

    }
}

::v-deep .firstCell {
    background-color: #F5F7FA;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell:not(.firstCell) {
    background-color: #fff;
}

::v-deep .cell {
    .el-input__inner {
        border: none;
    }
}

.lastStep {
    border-color: #699CE4;
    color: #699CE4;
}

.tit {
    font-size: 22px;
    font-weight: 500;
    color: #616161;
    margin: 30px 0 20px;
    span{
        // font-size: 16px;
        font-weight: normal;
        color: #f56c6c;
    }
}

::v-deep .el-step__head.is-finish {
    border-color: #616161;
    color: #616161;

    .el-step__icon {
        border-color: #616161;
        color: #616161;
    }

}

::v-deep .el-step__title.is-finish {
    color: #616161;
    font-weight: normal;
}

::v-deep .el-step__head.is-process {
    .el-step__icon {
        border-color: #6A9CE3;
        background: #6A9CE3;
        color: #fff;
    }
}

::v-deep .el-step__title.is-process {
    color: #6A9CE3;
    font-weight: normal;
}

::v-deep .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-steps {
        width: 582px;
    }

    .el-form .el-input:not(.el-transfer-panel__filter) {
        width: 250px;
    }
}

::v-deep .el-dialog__footer {
    padding: 10px 20px 30px;

    .dialog-footer {
        text-align: center;

        .el-button {
            // width: 70px;
            height: 30px;
            line-height: normal;
            padding: 0px 14px 2px;
            border-radius: 10px;
            margin: 0 10px;
        }
        .el-button--info.is-plain {
        color: #909399;
        background: #fff;
        border-color: #858585;
        }
    }
}

::v-deep .el-dialog__header {
    display: flex;
    padding: 30px 20px 10px;

    .el-dialog__title {
        flex: 1;
        text-align: center;
        color: #616161;
        font-size: 30px;
        font-weight: 500;
    }
}

.collapse-wrap {
    margin-top: 20px;
}

.tab-action {
    display: flex;
    align-items: center;
}

.r0,
.r1,
.r2 {
    width: 70px;
    height: 28px;
    border-radius: 5px;
    box-sizing: border-box;
    line-height: 27px;

}

.r0 {
    background: #F0F9EB;
    color: #67C23A;
    border: 1px solid #67C23A;
}

.r1 {
    background: rgba(255, 108, 108, 0.1);
    color: #FF6C6C;
    border: 1px solid #FF6C6C;
}

.r2 {
    border: 1px solid #699CE4;
    color: #699CE4;
    background: #DDEEFF;
}
</style>